import { render, staticRenderFns } from "./EditInsurance.vue?vue&type=template&id=53077b7c&scoped=true&"
import script from "./EditInsurance.vue?vue&type=script&lang=js&"
export * from "./EditInsurance.vue?vue&type=script&lang=js&"
import style0 from "./EditInsurance.vue?vue&type=style&index=0&id=53077b7c&prod&scoped=true&lang=css&"
import style1 from "./EditInsurance.vue?vue&type=style&index=1&id=53077b7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53077b7c",
  null
  
)

export default component.exports